const formFactoryEn = {
  progressLabels: {
    required: "Required",
    progress: "Progress",
  },
  collectionToggle: {
    skipInput: "Skip input",
  },
  fileField: {
    maxFiles: "Max {{count}} files",
    maxFileSize: "Max {{size}}MB per file",
    supportedFormats: "Supported formats: {{formats}}",
    noFilesSelected: "No files selected",
  },
  dynamicSelectField: {
    error: {
      loading: "Error loading options",
      loadingDescription: "Please try again later",
      selectDependencyFirst: "Please select a dependency field first",
    },
  },
  multiSelectCheckboxField: {
    noOptionsAvailable: "No options available",
  },
  defaultErrorComponent: {
    title: "Input errors:",
  },
};

export default formFactoryEn;
